<div class="badge badge-example">{{ data.title }}</div>